import { Controller } from "@hotwired/stimulus"

// Parent checkbox toggles all child checkboxes, and child changes update parent.
// Used by contracts/workflows/copies/new for importing workflows and tasks.
export default class extends Controller {
  static targets = ["parent", "child"]

  toggleChildren(event) {
    this.childTargets.forEach(child => {
      if (!child.disabled) {
        child.checked = event.target.checked
      }
    })
  }

  updateParent() {
    const checkedCount = this.childTargets.filter(child => child.checked).length
    this.parentTarget.checked = checkedCount > 0
  }
}
